<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div class="name-container font-gellix-bold-18-22">
      <span>{{ title }}</span>
      <div class="btn-grp">
        <input class="main-btn" type="submit" value="Go Back" (click)="goBack()" />
        <input class="main-btn ms-2" type="submit" value="Save Changes" (click)="saveChanges()" />
      </div>
    </div>
    <div class="details">
      <div class="heading">
        <span class="sub-heading">QUEUE DETAILS</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="col-3 form-group agent-detail-field">
          <label class="queue-detail-label" for="agentName">Name</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentName"
            placeholder="Agent Name"
            [value]="queueData?.Name"
          />
          <!-- <img alt="" class='select-agent' src='/assets/images/icon-ellipsis.png'>-->
        </div>

        <div class="col-3 form-group agent-detail-field">
          <label class="queue-detail-label" for="agentphone">Phone Number</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="agentphone"
            placeholder="Phone Number"
            [value]="queueData?.PhoneNumber"
          />
        </div>

        <div class="col-3 form-group agent-detail-field">
          <label class="queue-detail-label" for="queuetype">Queue Type</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="queuetype"
            placeholder="Type"
            [value]="queueType"
          />
        </div>

        <div class="col-3 form-group agent-detail-field">
          <label class="queue-detail-label" for="queue-length">Queue Length</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="queue-length"
            placeholder="Length"
            [value]="queueData?.Length"
          />
        </div>

        <div class="col-3 form-group agent-detail-field">
          <label class="queue-detail-label" for="created">Created</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="created"
            placeholder="Created"
            [value]="queueData?.Created | custdate"
          />
        </div>

        <div class="col-3 form-group agent-detail-field">
          <label class="queue-detail-label" for="lastupdated">Last updated on</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="lastupdated"
            placeholder="Updated"
            [value]="queueData?.LastUpdated | custdate"
          />
        </div>
        <div style="padding: 0rem">
          <label class="queue-detail-label" for="testingmode" class="checkbox-label">
            <input
              id="testingmode"
              type="checkbox"
              [ngModel]="testingCheck"
              (click)="modifyTestingCheck($event)"
              class="checkbox-box custom-checkbox"
            /><span class="checkbox-text">Testing Mode</span>
          </label>
        </div>
      </div>
    </div>

    <div class="details" *ngIf="showAvailabilityContainer">
      <div class="heading">
        <span class="sub-heading">AVAILABILITY</span>
        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group agent-detail-field">
          <label class="queue-detail-label" for="status">Status</label>
          <input
            type="text"
            name="status"
            [readonly]="true"
            class="form-control"
            class="inp"
            id="status"
            placeholder="Status"
            [value]="queueData?.Status"
          />
        </div>

        <label for="emergencycheck" class="emergency-check-label font-gellix-medium-13-15">
          <input
            id="emergencycheck"
            [ngModel]="emergencyCheck"
            (click)="modifyEmergencyCheck($event)"
            type="checkbox"
            value="test"
            class="checkbox-box custom-checkbox"
          /><span class="checkbox-text">Enable Emergency Message</span>
        </label>

        <div class="form-group agent-detail-field message-type-div">
          <label class="queue-detail-label" for="messagetype">Message Type</label>
          <select
            name="messagetype"
            class="inp custom-select"
            *ngIf="emergencyMessageType.length > 0"
            [ngModel]="selectedEmergencyMessageType.id"
            (change)="modifyEmergencyMessageType($event)"
            [disabled]="!emergencyCheck"
          >
            <ng-container *ngFor="let msg of emergencyMessageType">
              <option class="" [value]="msg.id">{{ msg.value }}</option>
            </ng-container>
          </select>
        </div>

        <!-- <button class="btn btn-default preview-btn" [disabled]="!emergencyCheck" *ngIf="!(queueData.Type =='TextChat')">
                        <img alt="" _ngcontent-xbo-c78="" src="{{baseHref}}/assets/images/icons-audio.png"
                            class="btn-img"><span class="btn-text"> Preview</span>
                    </button> -->
        <div style="padding: 0rem">
          <label
            for="bypass"
            class="checkbox-label bypass"
            [hidden]="!emergencyCheck"
            *ngIf="!(queueData.Type === 'TextChat')"
          >
            <input
              id="bypass"
              name="bypass"
              type="checkbox"
              [ngModel]="emergencyBypassIVRCheck"
              (click)="modifyEmergencyBypassIVRCheck($event)"
              value="test"
              class="checkbox-box custom-checkbox"
            />
            <label for="bypass1"></label>
            <span class="checkbox-text">Bypass IVR Flow and Route All Calls to Emergency Message</span>
          </label>
        </div>
        <div class="nxt-block" [hidden]="!emergencyCheck">
          <div class="form-group inp-desc agent-detail-field">
            <label for="emergencydesc">Emergency Message</label>
            <textarea
              type="text"
              class="form-control"
              class="inp"
              id="emergencydesc"
              placeholder=""
              [disabled]="!(selectedEmergencyMessageType.id === 'Custom')"
              [value]="emergencyMessageText"
            ></textarea>
          </div>
        </div>

        <app-message-view
          [isCampaign]="isCampaign"
          [hideLabel]="hideLabel"
          [hideFileName]="hideFileName"
          *ngIf="!(selectedEmergencyMessageType.id === 'AfterHours')"
          [label]="msglabel"
          (fileUploadEvent)="fileUpload($event)"
        ></app-message-view>

        <div class="nxt-block">
          <div class="form-group font-gellix-medium-13-15">
            <label class="row-label" for="availableon">Available On *</label>

            <label for="sun" class="checkbox-label week-checkbox-label">
              <input
                id="sun"
                type="checkbox"
                [ngModel]="sunday"
                (click)="modifyAvailableDayCheck($event, 'sunday')"
                value="test"
                class="checkbox-box custom-checkbox"
              /><span class="checkbox-text">Sun</span>
            </label>

            <label for="mon" class="checkbox-label week-checkbox-label">
              <input
                id="mon"
                type="checkbox"
                [ngModel]="monday"
                (click)="modifyAvailableDayCheck($event, 'monday')"
                value="test"
                class="checkbox-box custom-checkbox"
              /><span class="checkbox-text">Mon</span>
            </label>

            <label for="tue" class="checkbox-label week-checkbox-label">
              <input
                id="tue"
                type="checkbox"
                [ngModel]="tuesday"
                (click)="modifyAvailableDayCheck($event, 'tuesday')"
                value="test"
                class="checkbox-box custom-checkbox"
              /><span class="checkbox-text">Tue</span>
            </label>

            <label for="wed" class="checkbox-label week-checkbox-label">
              <input
                id="wed"
                type="checkbox"
                [ngModel]="wednesday"
                (click)="modifyAvailableDayCheck($event, 'wednesday')"
                value="test"
                class="checkbox-box custom-checkbox"
              /><span class="checkbox-text">Wed</span>
            </label>

            <label for="thu" class="checkbox-label week-checkbox-label">
              <input
                id="thu"
                type="checkbox"
                [ngModel]="thursday"
                (click)="modifyAvailableDayCheck($event, 'thursday')"
                value="test"
                class="checkbox-box custom-checkbox"
              /><span class="checkbox-text">Thu</span>
            </label>

            <label for="fri" class="checkbox-label week-checkbox-label">
              <input
                id="fri"
                type="checkbox"
                [ngModel]="friday"
                (click)="modifyAvailableDayCheck($event, 'friday')"
                value="test"
                class="checkbox-box custom-checkbox"
              /><span class="checkbox-text">Fri</span>
            </label>

            <label for="sat" class="checkbox-label week-checkbox-label">
              <input
                id="sat"
                type="checkbox"
                [ngModel]="saturday"
                (click)="modifyAvailableDayCheck($event, 'saturday')"
                value="test"
                class="checkbox-box custom-checkbox"
              /><span class="checkbox-text">Sat</span>
            </label>
          </div>
        </div>

        <div class="nxt-block font-gellix-medium-13-15">
          <div class="form-group">
            <label class="row-label" for="starttime">Time Between * </label>

            <div class="form-group inp-time">
              <label for="starttime" class="timepicker-label">Start Time</label>
              <!--<input name="starttime" type="time" [ngModel]="startTime" class="form-control" class='inp' id="starttime" placeholder=""
                                [value]="">-->
              <p-calendar
                [showTime]="true"
                [timeOnly]="true"
                hourFormat="12"
                [(ngModel)]="startTime"
                [iconDisplay]="'input'"
                [showIcon]="true"
              >
              </p-calendar>
            </div>

            <div class="form-group inp-time">
              <label for="endtime" class="timepicker-label">End Time</label>
              <!--<input name="endtime" type="time" [ngModel]="endTime" class="form-control" class='inp' id="endtime" placeholder=""
                                [value]="">-->
              <p-calendar
                [showTime]="true"
                [timeOnly]="true"
                hourFormat="12"
                [(ngModel)]="endTime"
                [iconDisplay]="'input'"
                [showIcon]="true"
              >
              </p-calendar>
            </div>
          </div>
        </div>

        <div class="nxt-block">
          <div class="form-group agent-detail-field timezone-div">
            <label for="timezone" class="timezone">Time Zone *</label>

            <select
              name="timezone"
              class="groupdropdown drpdown inp custom-select"
              *ngIf="timezones.length > 0"
              [(ngModel)]="timezoneSelect"
            >
              <option *ngFor="let item of timezones" [ngValue]="item">
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="details" *ngIf="showCallbackContainer">
      <div class="heading">
        <span class="sub-heading">CALLBACK SETTINGS</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="row">
          <div class="callback-queue-length">
            <label for="enableCallbacksByQLength">
              <input
                id="enableCallbacksByQLength"
                [ngModel]="callBackByQueueLengthCheck"
                (click)="modifyCallBackByQueueLengthCheck($event)"
                type="checkbox"
                value="test"
                class="checkbox-box custom-checkbox"
              /><span class="checkbox-text">Enable callbacks by queue length</span>
            </label>

            <div class="form-group agent-detail-field width100" *ngIf="callBackByQueueLengthCheck">
              <label class="callback-label" for="queueLength">Length</label>
              <input
                name="queueLength"
                type="text"
                class="form-control"
                class="inp"
                id="queueLength"
                placeholder="Length"
                [(ngModel)]="queueLengthMax"
                [value]="queueLengthMax"
              />
            </div>
          </div>
          <div class="callback-wait-time">
            <label for="enableCallbacksByWaitTime">
              <input
                id="enableCallbacksByWaitTime"
                [ngModel]="callBackByWaitTimeCheck"
                (click)="modifyCallBackByWaitTimeCheck($event)"
                type="checkbox"
                value="test"
                class="checkbox-box custom-checkbox"
              /><span class="checkbox-text">Enable callbacks by wait time</span>
            </label>

            <div class="form-group agent-detail-field width100" *ngIf="callBackByWaitTimeCheck">
              <label class="callback-label" for="timeInSeconds">Time in seconds</label>
              <input
                name="timeInSeconds"
                type="text"
                class="form-control"
                class="inp"
                id="timeInSeconds"
                placeholder="Time In Seconds"
                [(ngModel)]="waitTimeMax"
                [value]="waitTimeMax"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="details sla-window-ctrls" *ngIf="slaContainer">
      <div class="heading">
        <span class="sub-heading">SLA Window Controls</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="row" style="padding-left: 0.6rem">
          <div class="form-group agent-detail-field">
            <label class="queue-detail-label" for="preschedulecall">Pre-Schedule Call</label>
            <input
              type="text"
              [(ngModel)]="slaPreScheduleText"
              class="form-control"
              class="inp"
              id="preschedulecall"
              placeholder=""
              [value]="slaPreScheduleText"
            />
            <!-- <img alt="" class='select-agent' src='/assets/images/icon-ellipsis.png'>-->
          </div>

          <div class="form-group agent-detail-field">
            <label class="queue-detail-label" for="postschedulecall">Post-Schedule Call</label>
            <input
              type="text"
              class="form-control"
              class="inp"
              id="postschedulecall"
              placeholder=""
              [(ngModel)]="slaPostScheduleText"
              [value]="slaPostScheduleText"
            />
            <!-- <img alt="" class='select-agent' src='/assets/images/icon-ellipsis.png'>-->
          </div>
        </div>
        <div class="row" style="padding: 0.6rem">
          <div class="callback-wait-time">
            <label for="allowEarlyAppointments">
              <input
                id="allowEarlyAppointments"
                [ngModel]="allowEarlyFollowUpsCheck"
                (click)="modifyEarlyAppointmentsCheck($event)"
                type="checkbox"
                value="test"
                class="checkbox-box custom-checkbox"
              /><span class="checkbox-text">Allow Early Appointments</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="assign-agent-container">
      <app-assign-agents [details]="details"></app-assign-agents>
    </div>
  </div>
</div>

<!--<p-toast></p-toast>-->
<!--<p-confirmDialog [style]="{width: '290px',height:'150px'}"></p-confirmDialog>-->
